<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <ng-container *ngFor="let news of newses">
                <div class="card">
                    <div class="card-header" (click)="news.isCollapsed = !news.isCollapsed">
                        {{news.subject}}
                    </div>
                    <div class="card-body" [collapse]="news.isCollapsed" [innerHtml]="sanitized.bypassSecurityTrustHtml(news.content)"  >
                    </div>
                </div>
            </ng-container>
            <div class="card">
                <div class="card-header">
                    {{ 'user.auction_info' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3"><span>{{ 'user.n_results' | transloco: {count: (auctions.totalCount|number)} }}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #auctionGrid [isReadOnly]="true" style="height:200px" [itemsSource]="auctions">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'user.event_date' | transloco" [binding]="'eventDate'" [dataType]="'Date'" [width]="150" [isRequired]="true">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        {{item['eventDate']| date: 'yyyy/MM/dd HH:mm:ss'}}
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-input-date class="cell-editor" [(value)]="cell.value" [format]="'yyyy/MM/dd HH:mm:ss'" [isRequired]="true"></wj-input-date>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'user.venue' | transloco" [binding]="'place'" [width]="150">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-combo-box class="cell-editor" [itemsSource]="optionPlace" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="true"></wj-combo-box>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'user.lane' | transloco" [binding]="'lane'" [width]="150">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-combo-box class="cell-editor" [itemsSource]="optionLane" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="true"></wj-combo-box>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'user.status' | transloco" [binding]="'status'" [width]="150">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-combo-box class="cell-editor" [itemsSource]="optionStatus" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="true"></wj-combo-box>
                                    </ng-template>
                                </wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="auctions.pageSize" [header]="'user.page_size' | transloco">
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="auctions"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="auctions"></wj-collection-view-pager>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" *ngIf="tableType != 'list'">
                            <button (click)="tableType = 'list'" type="button" class="btn btn-block btn-success">{{ 'user.table_view' | transloco }}</button>
                        </div>
                        <div class="col-12" *ngIf="tableType != 'image'">
                            <button (click)="tableType = 'image'" type="button" class="btn btn-block btn-success">{{ 'user.image_view' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="tableType=='image'">
        <div class="row">
            <div class="col-md-4" *ngFor="let item of items.items">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <img *ngIf="item.images && item.images.length > 0" [src]="getImageSrc(item,item.images[0])" style="max-width: 350px; width: 100%;"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-2 col-md-2 form-control-label" style="font-size: 62.5%;">{{ 'user.item_id' | transloco }}</label>
                            <div class="col-4 col-md-4" style="font-weight: 700;">
                                {{item.id}}
                            </div>
                            <label class="col-2 col-md-2 form-control-label" style="font-size: 62.5%;">{{ 'user.item_category' | transloco }}</label>
                            <div class="col-4 col-md-4" style="font-weight: 700;">
                                {{item.category}}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-6 col-md-2 form-control-label" style="font-size: 62.5%;">{{ 'user.item_name' | transloco }}</label>
                            <div class="col-6 col-md-10" style="font-weight: 700;">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="row" [hidden]="tableType=='image'">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'user.listing_info' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3"><span>{{ 'user.n_results' | transloco: {count: (items.items.length|number)} }}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-multi-row *ngIf="screenWidth >= 768" #itemGrid [isReadOnly]="true" style="height:500px" [itemsSource]="items">
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='id' [header]="'user.item_id' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='images' [header]="'user.image' | transloco" [width]="100">
                                        <ng-template wjMultiRowCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            <img *ngIf="cell.item.images && cell.item.images.length > 0" [src]="getImageSrc(cell.item,cell.item.images[0])" height="50"/>
                                        </ng-template>
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='category' [header]="'user.item_category' | transloco" [width]="100">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='auctionResult' [header]="'user.auction_result' | transloco" [width]="100">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='name' [header]="'user.item_name' | transloco" [width]="150">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='description' [header]="'user.item_description' | transloco" [width]="200">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='quantity' [header]="'user.quantity' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='unit' [header]="'user.unit' | transloco" [width]="80">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='minimumPrice' [header]="'user.minimum_price' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='startPrice' [header]="'user.start_price' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                            </wj-multi-row>
                            <wj-multi-row *ngIf="screenWidth < 768" #itemGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="items">
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='id' [header]="'user.item_id' | transloco" [dataType]="'Number'" [width]="100">
                                    </wj-multi-row-cell>
                                    <wj-multi-row-cell binding='images' [header]="'user.image' | transloco" [width]="100">
                                        <ng-template wjMultiRowCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            <img *ngIf="cell.item.images && cell.item.images.length > 0" [src]="getImageSrc(cell.item,cell.item.images[0])" height="50"/>
                                        </ng-template>
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='category' [header]="'user.item_category' | transloco" [width]="100">
                                    </wj-multi-row-cell>
                                    <wj-multi-row-cell binding='auctionResult' [header]="'user.auction_result' | transloco" [width]="100">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='name' [header]="'user.item_name' | transloco" [width]="150">
                                    </wj-multi-row-cell>
                                    <wj-multi-row-cell binding='description' [header]="'user.item_description' | transloco" [width]="150" [rowspan]="2">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                                <wj-multi-row-cell-group>
                                    <wj-multi-row-cell binding='quantity' [header]="'user.quantity' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                    <wj-multi-row-cell binding='minimumPrice' [header]="'user.minimum_price' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                    <wj-multi-row-cell binding='startPrice' [header]="'user.start_price' | transloco" [dataType]="'Number'" [width]="80">
                                    </wj-multi-row-cell>
                                </wj-multi-row-cell-group>
                            </wj-multi-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

